import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../../../store/auth.store';
import { ERoutes } from '../../enums';
import { PlatformService } from '../../../services/platform/platform.service';


const authStore = () => inject(AuthStore);
const router = () => inject(Router)
const platform = () => inject(PlatformService)

export const authGuard: CanActivateFn = (route, state) => {
  if (!authStore().isAuthenticated()) {
    platform().isPlatformBrowser() && router().navigate([`/${ERoutes.welcome}`]);
    return false
  }
  return true;
};

export const guestGuard: CanActivateFn = (route, state) => {
  if (authStore().isAuthenticated()) {
    platform().isPlatformBrowser() && router().navigate([`/${ERoutes.home}`]);
    return false;
  }
  return true
};
